import { Component, Inject, OnInit } from '@angular/core';
import { CrudModeEnum } from '../../../../../../core/base/enum/crud-mode.enum';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { EstablishmentCustomerModel, EstablishmentModel } from '../../../../../../core/models/establishment.model';
import { FormModalBaseComponent } from '../../../../../../core/base/components/form-modal-base/form-modal-base.component';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SnackbarService } from '../../../../../../core/services/snackbar.service';
import { EstablishmentService } from '../../establishment.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'vex-establishment-customer-create-update-delete',
  templateUrl: './establishment-customer-create-update-delete.component.html',
  styleUrls: ['./establishment-customer-create-update-delete.component.scss'],
})
export class EstablishmentCustomerCreateUpdateDeleteComponent
  extends FormModalBaseComponent<EstablishmentModel>
  implements OnInit
{
  defaults: EstablishmentModel;
  mode: CrudModeEnum;
  form: UntypedFormGroup;
  loading = false;

  filters = {};
  establishments$: Observable<any[]>;

  establishmentCustomer: EstablishmentCustomerModel;
  dependencies: any;
  hasDependencies = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<FormModalBaseComponent<EstablishmentModel>>,
    public establishmentService: EstablishmentService,
    public snackbarService: SnackbarService,
  ) {
    super(data, dialogRef, establishmentService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (this.isCreateMode()) {
      this.initData();
      this.establishmentAutocompleteChange();
    }

    if (this.isDeleteMode()) {
      this.establishmentCustomer = this.data.establishmentCustomer;
      this.dependencies = this.data.dependencies;
      this.hasDependencies = !!this.dependencies?.hasDependencies;
    }
  }

  initData() {
    const excludedIds =
      this.defaults?.establishmentCustomers?.map((ec: EstablishmentCustomerModel) => ec.customer_id) || [];

    // Exclure aussi l'établissement principal s'il existe
    const mainEstablishmentId = this.defaults?.mainEstablishmentId;
    const allExcludedIds = [this.defaults._id, ...excludedIds];

    if (mainEstablishmentId) {
      allExcludedIds.push(mainEstablishmentId);
    }

    this.filters = {
      excludedIds: allExcludedIds,
      requiredFields: ['_id', 'label', 'technicalIdentifier'],
    };

    this.form = new UntypedFormGroup({
      establishment: new UntypedFormControl(null, [Validators.required]),
    });
  }

  establishmentAutocompleteChange(search = '') {
    this.establishments$ = this.establishmentService
      .findAll(null, null, 'label', 'asc', search, this.filters)
      .pipe(map(x => x.data));
  }

  createItem() {
    this.loading = true;

    if (this.form.valid) {
      const establishmentCustomer = this.form.controls.establishment.value;

      const convertedEstablishmentCustomer = {
        _id: establishmentCustomer._id,
        label: establishmentCustomer.label,
        technicalIdentifier: establishmentCustomer.technicalIdentifier,
      };

      const sub = this.establishmentService
        .addEstablishmentCustomer(this.defaults._id, [convertedEstablishmentCustomer])
        .subscribe(
          res => {
            this.close(res);
            this.loading = false;
          },
          err => {
            this.setErrorsMessages(err.error?.errors);
            this.loading = false;
          },
        );
      this.subscription.add(sub);
    } else {
      this.form.markAllAsTouched();
      this.loading = false;
    }
  }

  close(data?: any): void {
    this.dialogRef.close(data);
  }

  isDeleteMode() {
    return this.mode === CrudModeEnum.Delete;
  }

  isCreateMode() {
    return this.mode === CrudModeEnum.Create;
  }

  deleteItem() {
    this.loading = true;
    const sub = this.establishmentService
      .deleteEstablishmentCustomer(this.defaults._id, this.establishmentCustomer._id)
      .subscribe(
        res => {
          this.snackbarService.success("L'établissement client a bien été supprimé !");
          this.afterDeleteItem(res, null);
          this.loading = false;
        },
        err => {
          this.setErrorsMessages(err.error?.errors);
          this.loading = false;
        },
      );
    this.subscription.add(sub);
  }
}
